import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo-tracker.svg'


const _hoisted_1 = { class: "page-auth" }
const _hoisted_2 = {
  href: "https://www.tracker.com/",
  class: "auth-powered",
  target: "_blank"
}
const _hoisted_3 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('pages.auth.login.powered_by')) + " ", 1),
      _createElementVNode("img", {
        src: _imports_0,
        alt: _ctx.$t('pages.auth.login.powered_by_alt')
      }, null, 8, _hoisted_3)
    ])
  ]))
}